export function getDeliveryOptionLabel(t, deliveryOption) {
  switch (deliveryOption) {
    case 'SELF-DELIVER':
      return t('donations.delivery-option-values.SELF-DELIVER');
    case 'PAID-PREMIUM-PICKUP':
      return t('donations.delivery-option-values.PAID-PREMIUM-PICKUP');
    case 'RECEIVER-PICKUP':
      return t('donations.delivery-option-values.RECEIVER-PICKUP');
    case 'DELIVERY-BY-FOOD-MOVER':
      return t('donations.delivery-option-values.DELIVERY-BY-FOOD-MOVER');
    case 'STAFF-MEALS':
      return t('donations.delivery-option-values.STAFF-MEALS');
    default:
      return t('donations.delivery-option-values.null');
  }
}
